import { Component, inject } from '@angular/core';
import { AppStateService } from './Services/AppState/app-state.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoadingComponent } from 'npx-arc-ui/loading';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule
    , RouterModule
    , LoadingComponent
  ]
})
export class AppComponent {
  title = 'Portal Defontana';
  appState = inject(AppStateService)
}
